module.exports = __webpack_public_path__ + "static/media/back.e903ae1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/back.svg
// module id = 469
// module chunks = 7